import React from "react";


const RaceCardItem = ({ race, lnk }) => {
  if (!race) return null;

  const {
    nm = "Race Name",
    dis = "",
    nor = "",
    rc = "",
    // st = "",
    // time = "",
  } = race;

  // const raceTime = time || "—";
  return (
    <div className="race_card_item">
      <a href={lnk}>
        {/* <span className="date">{raceTime}</span> */}
        <div className="desc">
          <strong className="desc_title">{nm}</strong>
          <span className="desc_sb_inf">
            {nor ? `${nor} Runners` : ""}
            {rc ? `, ${rc}` : ""}
            {dis ? `, ${dis}` : ""}
          </span>
        </div>
        <i className="ico ico_right_arrow_bold"></i>
      </a>

    </div>
  );
};

export default RaceCardItem;
